import React, { Component } from 'react';
import "./navigation.css";
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link
} from "react-router-dom";

export default function NavigationItem(item) {
    var text = item.text;
    if (item.type == "summary" || item.type == "reports" || item.type == "analytics" || item.type == "clients" || item.type == "users" || item.type == "settings" || item.type == "analyticsManagement" || item.type == "reportsManagement" || item.type == "data" || item.type == "bannerSwitch") {
        text = text.toUpperCase();
    }

    var icon = "navigationIcon";
    var path = '/position';

    if (item.type == "summary") {
        icon = icon + " dx-icon-formula";
        path = '/summary';
    }

    if (item.type == "reports") {
        icon = icon + " dx-icon-doc";
        path = '/reports';
    }

    if (item.type == "reportsManagement") {
        icon = icon + " dx-icon-doc";
        path = '/reportsManagement';
    }

    if (item.type == "analytics") {
        icon = icon + " dx-icon-tips";
        path = '/analytics';
    }

    if (item.type == "analyticsManagement") {
        icon = icon + " dx-icon-tips";
        path = '/analyticsManagement';
    }

    if (item.type == "product") {
        icon = icon + " dx-icon-product";
    }

    if (item.type == "portfolio") {
        icon = icon + " dx-icon-bulletlist";
    }

    if (item.type == "fund") {
        icon = icon + " dx-icon-bulletlist";
    }

    if (item.type == "users") {
        icon = icon + " dx-icon-group";
        path = '/users';
    }

    if (item.type == "bannerSwitch") {
        icon = icon + " dx-icon-group";
        path = '/bannerSwitch';
    }

    if (item.type == "settings") {
        icon = icon + " dx-icon-preferences";
        path = '/settings';
    }

    if (item.type == "data") {
        icon = icon + " dx-icon-refresh";        
    }

    return (
        <div className={'product'}>
            <span className={icon}></span>{text}
        </div>
    );
}

////<Link to="/position">{item.text}</Link>                


// WEBPACK FOOTER //
// ./App/containers/navigation/navigationItem.jsx